import * as msal from "@azure/msal-browser";
import { DUClaims } from "../authContext";
interface DUUser extends msal.AccountInfo {
    name: string;
    username: string;
}
type DUToken = {
    idToken: string;
    accessToken: string;
}
export type UserAndClaims = {
    claims: DUClaims | null;
    user: DUUser | null;
    token: DUToken | null;
    error?: msal.AuthError;
}
const getUserAndClaims = (pc: msal.PublicClientApplication, response: msal.AuthenticationResult) => {
    const accounts = pc.getAllAccounts();
    let result: any = {}
    if (accounts?.length) {
        const claims = response.idTokenClaims as DUClaims;
        result.claims = claims;
        result.user = { ...accounts[0], name: `${claims.given_name} ${claims.family_name}`, username: claims.email } as DUUser;
    }
    if (response.idToken) {
        result.token = { idToken: response.idToken, accessToken: response.accessToken } as DUToken;
    }
    return result as UserAndClaims;
}
export default getUserAndClaims;